import { hasWindow } from "@utils/general";

import { PureAemComponent, registerComponent } from "@components/pureAemComponent";

import "./description.scss";

let Dotdotdot: any;

try {
    Dotdotdot = require("dotdotdot-js").default;
} catch (_) {
    Dotdotdot = class {};
}

class Description extends PureAemComponent {
    textWrapper: HTMLElement | null;
    moreButton: HTMLElement | null;
    lessButton: HTMLElement | null;
    dot?: any;

    constructor(element: HTMLElement) {
        super(element);
        this.textWrapper = element.querySelector(
            ".js-product-description__content",
        );
        this.moreButton = element.querySelector(
            ".js-product-description__link--more",
        );
        this.lessButton = element.querySelector(
            ".js-product-description__link--less",
        );

        this.init();
    }

    /**
     * Initialize the component
     * - init the truncation lib
     * - bind the event handlers
     */
    init() {
        this.truncateText();
        this.bindEventHandlers();
    }

    /**
     * Initialize the Dotdotdot lib on the wrapper
     */
    truncateText() {
        if (this.textWrapper) {
            this.dot = new Dotdotdot(this.textWrapper, {
                callback: (isTruncated: boolean) => {
                    if (isTruncated) {
                        // Show the read more button when it's applicable
                        this.moreButton?.classList.remove("d-none");
                    }
                },
                ellipsis: "\u2026 ",
                truncate: "word",
                watch: "window",
            });
        }
    }

    /**
     * Bind the event handlers to the functions
     */
    bindEventHandlers() {
        this.moreButton?.addEventListener("click", this.setFullText.bind(this));
        this.lessButton?.addEventListener(
            "click",
            this.setPreviewText.bind(this),
        );
    }

    /**
     * Show the original text and unwatch the wrapper
     * - Switch the visibility link buttons
     * @param e
     */
    setFullText(e: Event) {
        e.preventDefault();
        this.moreButton?.classList.add("d-none");
        this.lessButton?.classList.remove("d-none");
        this.dot?.restore();
        this.dot?.unwatch();
    }

    /**
     * Show the preview text and watch the wrapper again
     * - Switch the visibility link buttons
     * @param e
     */
    setPreviewText(e: Event) {
        e.preventDefault();
        this.moreButton?.classList.remove("d-none");
        this.lessButton?.classList.add("d-none");
        this.dot?.truncate();
        this.dot?.watch();
    }
}
const InitDescription = () => {
    hasWindow() && registerComponent(".js-product-description", Description);
};

export { InitDescription };
